import DocumentationButton from "components/DocumentationButton";
import {
  EmptystateCodeBrowserColored,
  EmptystateSearchNoResultsColored,
} from "components/icons/generated";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";
import { getDocsUrl } from "utils/getDocsUrl";

type TemplateDeploymentEmptyProps = {
  hasNoResults?: boolean;
};

const TemplateDeploymentEmpty = ({ hasNoResults }: TemplateDeploymentEmptyProps) => {
  return (
    <>
      {hasNoResults && (
        <EmptyState
          title="No results"
          caption="Try different filters."
          icon={EmptystateSearchNoResultsColored}
          announce
        />
      )}

      {!hasNoResults && (
        <EmptyState title="You don’t have any deployments yet" icon={EmptystateCodeBrowserColored}>
          <Box gap="medium">
            <DocumentationButton to={getDocsUrl("/concepts/template")} label="Documentation" />
          </Box>
        </EmptyState>
      )}
    </>
  );
};

export default TemplateDeploymentEmpty;
